import React, { useEffect } from 'react';
import { Form, Modal } from '@bedrock/components';
import withFunctionCall from '#utils/withFunctionCall';
import SFormItem from '@mpc/common/src/components/SForm/SFormItem';
import DesignatedExpert from '../DesignatedExpert';

const AddExpertModal = ({
  l3_category_id,
  planData,
  ...props
}) => {
  const [form] = Form.useForm();
  const [formData, setFormData] = React.useState<any>({})

  useEffect(() => {
    form.setFieldsValue({
      planData
    })
    setFormData({
      planData
    })
  }, [planData])

  return (
    <Modal
      {...props}
      title={`手动添加达人(${formData.planData?.length || 0})`}
      onOk={async () => {
        const values = await form.validateFields();
        props.onOk?.(values?.planData);
        props.onCancel?.();
      }}
      maskClosable={false}
    >
      <div className='min-h-[350px]'>
        <Form form={form} onValuesChange={(changedValues, values) => {
          setFormData(values)
        }}>
          <SFormItem
            showLabel={false}
            formItemKey={['planData']}
            watchChildFormValidate
            validateTrigger={['submit']}
            render={() => 
              <DesignatedExpert l3_category_id={l3_category_id} type='addPlanData'  />
            }
          />
        </Form>
      </div> 
    </Modal>
  )
}

export default withFunctionCall(AddExpertModal)
